export default __webpack_public_path__ + "static/media/house-bg.e8f3886d.jpeg";